// extracted by mini-css-extract-plugin
export default {"list":"Icons_list__N5Amb","listItem":"Icons_listItem__Fjurf","icon":"Icons_icon__5vljy","gitHubIcon":"Icons_gitHubIcon__XbNC7"};